import { WIDGET_LAYOUT } from '../interfaces/widgetLayout';

export const WIDGET_LAYOUT_MAP: Record<number, WIDGET_LAYOUT> = {
  0: {
    id: 0,
    name: '',
    visible: false,
    className: 'widget-esperienze-map',
    fixedWidth: true,
    goLarge: false,
  },
  1: {
    id: 1,
    name: '',
    visible: false,
    className: 'widget-heatmap',
    fixedWidth: true,
    goLarge: false,
  },
  2: {
    id: 2,
    name: '',
    visible: false,
    className: 'widget-attivita',
    fixedWidth: true,
    goLarge: false,
  },
  3: {
    id: 3,
    name: '',
    visible: false,
    className: 'widget-curva-accesso',
    fixedWidth: true,
    goLarge: false,
  },
  4: {
    id: 4,
    name: '',
    visible: false,
    className: 'widget-curva-mercato',
    fixedWidth: true,
    goLarge: false,
  },
  5: {
    id: 5,
    name: '',
    visible: false,
    className: 'widget-mapOpenAccess',
    fixedWidth: true,
    goLarge: false,
  },
  6: {
    id: 6,
    name: '',
    visible: false,
    className: 'widget-evolution-regional-access',
    fixedWidth: true,
    goLarge: false,
  },
  7: {
    id: 7,
    name: '',
    visible: false,
    className: 'widget-monitoringForecastVsActualRegionalLevel',
    fixedWidth: true,
    goLarge: false,
  },
  8: {
    id: 8,
    name: '',
    visible: false,
    className: 'widget-forecastTimeProgress',
    fixedWidth: true,
    goLarge: false,
  },
  9: {
    id: 9,
    name: '',
    visible: false,
    className: 'widget-nHospitalsAndExperiences',
    fixedWidth: true,
    goLarge: false,
  },
  10: {
    id: 10,
    name: '',
    visible: false,
    className: 'widget-evolution-regional-market',
    fixedWidth: true,
    goLarge: false,
  },
  11: {
    id: 11,
    name: '',
    visible: false,
    className: 'widget-map-forecast-complete-access',
    fixedWidth: true,
    goLarge: false,
  },
  12: {
    id: 12,
    name: '',
    visible: false,
    className: 'widget-monitoringCompleteAccess',
    fixedWidth: true,
    goLarge: false,
  },
  13: {
    id: 13,
    name: '',
    visible: false,
    className: 'widget-monitoringAggiudicazione',
    fixedWidth: true,
    goLarge: false,
  },
  14: {
    id: 14,
    name: '',
    className: 'widget-inclusion-process-tool-national',
    visible: true,
    fixedWidth: true,
    goLarge: false,
  },
15: {
    id: 15,
    name: '',
    visible: true,
    className: 'widget-heatmap-economia',
    fixedWidth: true,
    goLarge: false,
  },
  16: {
    id: 16,
    name: '',
    visible: true,
    className: 'widget-curva-economia',
    fixedWidth: true,
    goLarge: false,
  },
  17: {
    id: 17,
    name: '',
    visible: true,
    className: 'widget-forecast-accuracy-openToAccess',
    fixedWidth: true,
    goLarge: false,
  },
    18: {
    id: 18,
    name: '',
    visible: true,
    className: 'widget-forecast-accuracy-openToEconomia',
    fixedWidth: true,
    goLarge: false,
  },
  19: {
    id: 19,
    name: '',
    visible: true,
    className: 'widget-forecast-accuracy-openToMarket',
    fixedWidth: true,
    goLarge: false,
  },
    20: {
    id: 20,
    name: '',
    visible: true,
    className: 'widget-evolution-regional-economia',
    fixedWidth: true,
    goLarge: false,
  },
      21: {
    id: 21,
    name: '',
    visible: true,
    className: 'widget-curva-mercato-30-giorni',
    fixedWidth: true,
    goLarge: false,
  },
        22: {
    id: 22,
    name: '',
    visible: true,
    className: 'widget-evolution-regional-market-30-days',
    fixedWidth: true,
    goLarge: false,
  },
  23: {
    id: 23,
    name: '',
    visible: true,
    className: 'widget-curva-mercato-30-giorni-merged',
    fixedWidth: true,
    goLarge: false,
  },

};
